var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"integration-logo",style:(_vm.logoStyle)},[(_vm.hasLogo)?_c('img',{class:_vm.logoClass,attrs:{"src":_vm.logoUrl,"alt":_vm.altText}}):_c('v-icon',{attrs:{"color":"primary","size":"32"}},[_vm._v("mdi-link-variant")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }